import { render, staticRenderFns } from "./ProcessSetting.vue?vue&type=template&id=345585f5&scoped=true&"
import script from "./ProcessSetting.vue?vue&type=script&lang=js&"
export * from "./ProcessSetting.vue?vue&type=script&lang=js&"
import style0 from "./ProcessSetting.vue?vue&type=style&index=0&id=345585f5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345585f5",
  null
  
)

export default component.exports